import React from "react";
import { useParams } from "react-router-dom";
import { ChangeServiceTariffDetails as ChangeServiceTariffDetailsRemote } from "@/App/components/@remote";

export const ChangeServiceTariffDetails = () => {
  const { id } = useParams();
  return <ChangeServiceTariffDetailsRemote id={id ?? ""} />;
};
